import { render, staticRenderFns } from "./new-category-form.vue?vue&type=template&id=3bf98b16&scoped=true"
import script from "./new-category-form.vue?vue&type=script&lang=js"
export * from "./new-category-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf98b16",
  null
  
)

export default component.exports